import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TypeInput = ({ label, value, onFocus, onBlur, onChange, onKeyDown }) => {
    const { t } = useTranslation('customer.address.map-polygons');

    return (
        <div
            data-type-group
            className="m2g-customer-address-type m2g-customer-address-form-group"
        >
            <div
                data-type-label
                className="m2g-customer-address-form-group-label"
            >
                {label}
            </div>
            <div
                className="m2g-input-container m2g-customer-address-form-group-controls m2g-form-element-group"
                data-icon-after="select"
            >
                <select
                    data-type
                    data-field="type"
                    value={value}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    className="m2g-customer-address-type-select m2g-select m2g-form-element--full-width"
                >
                    <option value="residential">
                        {t('residential_address')}
                    </option>
                    <option value="business">{t('business_address')}</option>
                    <option value="apartment">{t('apartment')}</option>
                    <option value="hotel">{t('hotel')}</option>
                </select>
            </div>
        </div>
    );
};

TypeInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default TypeInput;
